export const PLATFORM = "web";